var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import styled, { css } from 'styled-components';
import ButtonGroupElement from './ButtonGroupElement';
import Button from '../Button';
import { ThemeFamilies } from '../../theme/families';
export var ButtonGroupVariants;
(function (ButtonGroupVariants) {
    ButtonGroupVariants["PRIMARY"] = "primary";
    ButtonGroupVariants["SPACED_BUTTONS"] = "spaced_buttons";
})(ButtonGroupVariants || (ButtonGroupVariants = {}));
var UnifiedButtonGroupElement = function (props) { return (_jsx(StyledButtonGroupElement, __assign({}, props, { onClick: function (_, e) { return props.onClick(e); }, isActive: props.isActive || false, label: props.label || '', family: props.themeFamily }), void 0)); };
var getButtonGroupByVariant = function (variant) {
    switch (variant) {
        case ButtonGroupVariants.PRIMARY:
            return UnifiedButtonGroupElement;
        case ButtonGroupVariants.SPACED_BUTTONS:
            return Button;
        default:
            return UnifiedButtonGroupElement;
    }
};
var getWrapperByVariant = function (variant) {
    switch (variant) {
        case ButtonGroupVariants.PRIMARY:
            return PrimaryButtonGroupWrapper;
        case ButtonGroupVariants.SPACED_BUTTONS:
            return BaseButtonGroupWrapper;
        default:
            return PrimaryButtonGroupWrapper;
    }
};
var ButtonGroup = function (_a) {
    var staticSize = _a.staticSize, options = _a.options, value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange, disabled = _a.disabled, className = _a.className, name = _a.name, variant = _a.variant;
    var ButtonGroupVariant = getButtonGroupByVariant(variant);
    var ButtonGroupWrapper = getWrapperByVariant(variant);
    var _b = useState(defaultValue), internalActiveButton = _b[0], setInternalActiveButton = _b[1];
    var currentActiveButton = value !== null && value !== void 0 ? value : internalActiveButton;
    var handleButtonClick = function (buttonValue, e) {
        if (!value) {
            setInternalActiveButton(buttonValue);
        }
        if (onChange) {
            onChange(buttonValue, e);
        }
    };
    return (_jsx(ButtonGroupWrapper, __assign({ disabled: disabled, className: className, "data-testid": name }, { children: options === null || options === void 0 ? void 0 : options.filter(function (item) { return !item.hide; }).map(function (button) { return (_jsx(ButtonGroupVariant, { staticSize: staticSize, onClick: function (e) { return handleButtonClick(button.value, e); }, isActive: currentActiveButton === button.value, themeFamily: button.family, variant: button.variant, label: button.label, children: button.label, hide: button.hide, name: button.name, disabled: disabled || button.disabled, type: "button" }, button.value.toString())); }) }), void 0));
};
export default ButtonGroup;
export var StyledButtonGroupElement = styled(ButtonGroupElement)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var BaseButtonGroupWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  width: fit-content;\n\n  &[disabled] {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  & > :not(:last-child) {\n    margin-right: 4px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  width: fit-content;\n\n  &[disabled] {\n    cursor: default;\n    pointer-events: none;\n  }\n\n  & > :not(:last-child) {\n    margin-right: 4px;\n  }\n"])));
var PrimaryButtonGroupWrapper = styled(BaseButtonGroupWrapper)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 4px;\n  border-radius: 8px;\n\n  ", "\n\n  &[disabled] {\n    cursor: default;\n    pointer-events: none;\n\n    ", " {\n      border: none;\n    }\n  }\n\n  & > :not(:last-child) {\n    margin-right: 4px;\n  }\n"], ["\n  padding: 4px;\n  border-radius: 8px;\n\n  ",
    "\n\n  &[disabled] {\n    cursor: default;\n    pointer-events: none;\n\n    ", " {\n      border: none;\n    }\n  }\n\n  & > :not(:last-child) {\n    margin-right: 4px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    var _b = theme.families.buttonGroup[ThemeFamilies.PRIMARY], main = _b.main, light = _b.light;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: ", ";\n      border: 1px solid ", ";\n    "], ["\n      background-color: ", ";\n      border: 1px solid ", ";\n    "])), light, main);
}, StyledButtonGroupElement);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
